let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iIJzF")).then(() => parcelRequire('lbe7B'));